<template>
  <div class="donation-form">
    <fieldset>
      <SumSelector/>
      <div class="row">
        <div class="column column-100">
          <MonthSwitcher/>
        </div>
      </div>
      <div class="row">
        <div class="column column-100">
          <MethodSwitcher/>
        </div>
      </div>
      <div v-if="!isLinkMethod()">
        <div v-if="checkoutType === 'widget'">
          <div class="row">
            <div class="column column-100">
              <StripeElementPayment ref="paymentWidget" :pk="checkoutParams.publicKey" :elements-options="{ clientSecret: checkoutParams.clientSecret, appearance }" :confirm-params="{ return_url: returnUrl }" @error="showErrorPage" />
            </div>
          </div>
          <div class="row">
            <div class="column">
              <button class="button button-outline donate" @click="requestTransaction">{{ action }}</button>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row">
            <div class="column column-100">
              <Email/>
            </div>
          </div>
          <div class="row">
            <div class="column column-100">
              <input type="text" name="firstname" @input="updateValue" :placeholder="labels['name']" :value="firstname">
            </div>
          </div>
          <div class="row">
            <div class="column">
              <Agreement/>
            </div>
          </div>
          <div class="row">
            <div class="column">
              <button class="button button-outline donate" @click="donate">{{ action }}</button>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div class="column method-description">
            {{ labels[activeMethod + '-description'] }}
          </div>
        </div>
        <div class="row">
          <div class="column">
            <a class="button button-outline donate" :href="methods[activeMethod].url" target="_blank">{{ labels[activeMethod + '-label'] }}</a>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { StripeElementPayment } from '@vue-stripe/vue-stripe'
import SumSelector from '@/components/shared/SumSelector.vue'
import MethodSwitcher from '@/components/shared/MethodSwitcher.vue'
import MonthSwitcher from '@/components/shared/MonthSwitcher.vue'
import Email from '@/components/shared/Email.vue'
import Agreement from '@/components/shared/Agreement.vue'
import { LABELS, VALIDATION_MESSAGES } from '@/settings'

export default {
  components: { Agreement, Email, MethodSwitcher, MonthSwitcher, SumSelector, StripeElementPayment },
  computed: mapState({
    firstname: state => state.donation.firstname,
    email: state => state.donation.email,
    month: state => state.donation.month,
    terms: state => state.terms,
    lang: state => state.language,
    labels: state => LABELS[state.language],
    action: state => LABELS[state.language][state.donation.month ? 'subscribe' : 'donate'],
    activeMethod: state => state.donation.method,
    methods: state => state.operators,
    checkoutType: state => state.checkoutType,
    checkoutParams: state => state.checkoutParams,
    returnUrl: state => `${document.location.origin}/complete?donationId=${state.internalDonationId}`,
    sum: state => state.donation.sum
  }),
  data () {
    return {
      appearance: {},
      confirmParams: {
        return_url: ''
      }
    }
  },
  methods: {
    isLinkMethod () {
      return !!this.methods[this.activeMethod].url
    },
    updateValue (e) {
      const prop = e.target.name
      const value = e.target.value
      const change = { prop, value }
      this.$store.commit('updateDonation', change)
    },
    donate () {
      if (!this.sum) {
        return
      }
      // TODO missing validation scope, returns true even when has errors
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('donate')
        }
      })
    },
    requestTransaction () {
      this.$refs.paymentWidget.submit()
    },
    resetForm () {
      this.$store.dispatch('resetForm')
    },
    showSuccessPage () {
      this.$store.dispatch('showStep', 'thanks')
    },
    showErrorPage () {
      this.$store.dispatch('showStep', 'error')
    }
  },
  mounted () {
    const lang = this.lang
    this.$validator.localize(lang, VALIDATION_MESSAGES[lang])
  }
}
</script>

<style scoped>
  .oi-donation-form fieldset,
  .oi-donation-form input,
  .oi-donation-form select,
  .oi-donation-form textarea {
    margin-bottom: 10px;
  }
  .oi-donation-form .method-description {
    margin-bottom: 10px!important;
  }
</style>
